import { render, staticRenderFns } from "./NewlyaddedOrderListModel_shujugeli.vue?vue&type=template&id=5fb9803d&scoped=true&"
import script from "./NewlyaddedOrderListModel_shujugeli.vue?vue&type=script&lang=js&"
export * from "./NewlyaddedOrderListModel_shujugeli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb9803d",
  null
  
)

export default component.exports